import React from 'react';
import "./Advantage.css";

const Advantage = () => {
  return (
    <div className='advantage'>
      <div className="advantage1">
        <p>Why Choose a <label>Unified Tech Suite</label></p>
        <p>For POS, ERP, Web & Mobile</p>
        <p>and Digital Operations?</p>
      </div>
    </div>
  );
};

export default Advantage;